import { Environment } from '@cobliteam/react-environments';
import { SessionManager } from '../../account/session/SessionManager';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import type { WebhooksAddContent, WebhooksUpdateContent } from './Definitions/Types';
import { webhooksTransformer } from './WebhooksTransformers';

const env = Environment.getInstance().getEnvironment();

export class WebhooksRequester {
  private requester: Requester;

  constructor() {
    const sessionManager = new SessionManager({ host: env.experience });
    this.requester = new Requester({ host: env.experience }, sessionManager);
  }

  public getWebhooks = (): Promise<WebhooksUpdateContent[]> => {
    const requestData: IRequest = {
      endpoint: '/v1/signatures',
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => webhooksTransformer(response.data));
  };

  public generateNewWebhook = (webhookInfo: WebhooksAddContent): Promise<string> => {
    const requestData: IRequest = {
      endpoint: '/v1/signatures',
      method: HttpMethod.POST,
      body: JSON.stringify({
        name: webhookInfo.name,
        event_types: webhookInfo.eventTypes,
        secret_key: webhookInfo.secretKey,
        url: webhookInfo.url,
        custom_headers: webhookInfo.customHeaders,
      }),
    };

    return this.requester.request(requestData).then((response) => response.data);
  };

  public updateWebhook = (webhookInfo: WebhooksUpdateContent): Promise<string> => {
    const requestData: IRequest = {
      endpoint: `/v1/signatures/${webhookInfo.id}`,
      method: HttpMethod.PATCH,
      body: JSON.stringify({
        id: webhookInfo.id,
        name: webhookInfo.name,
        event_types: webhookInfo.eventTypes,
        secret_key: webhookInfo.secretKey,
        url: webhookInfo.url,
        custom_headers: webhookInfo.customHeaders,
      }),
    };

    return this.requester.request(requestData).then((response) => response.data);
  };

  public revokeWebhooks = (webhookId: string): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `/v1/signatures/${webhookId}`,
      method: HttpMethod.DELETE,
    };

    return this.requester.request(requestData).then();
  };

  public testWebhooks = (webhookInfo: WebhooksAddContent): Promise<boolean> => {
    const requestData: IRequest = {
      endpoint: 'https://api.cobli.co/public/v1/signatures/test',
      method: HttpMethod.POST,
      body: JSON.stringify({
        url: webhookInfo.url,
        headers: webhookInfo.customHeaders,
        secret_key: webhookInfo.secretKey,
      }),
    };

    return this.requester
      .request(requestData)
      .then((response) => {
        return response.status >= 200 && response.status < 300;
      })
      .catch((err) => {
        return err.message;
      });
  };
}

export default WebhooksRequester;
